import { ComponentClass, FunctionComponent } from 'react';

import SignUpAccount from './SignUpAccount';
import SignUpComplete from './SignUpComplete';
import SignUpStart from './SignUpStart';

export interface IPageConfig {
  component: ComponentClass | FunctionComponent;
  link: string;
  path: string;
}

const startPage: IPageConfig = {
  component: SignUpStart,
  link: '/start',
  path: 'start',
};

export const pages: Array<IPageConfig> = [
  startPage,
  {
    component: SignUpAccount,
    link: '/account',
    path: 'account',
  },
  {
    component: SignUpComplete,
    link: '/complete',
    path: 'complete',
  },
];
